export default [
  {
    path: '/game-center',
    name: 'GameCenter',
    component: () => import('../../views/game/center.vue'),
    meta: {
      auth: true,
      title: '游戏中心',
      keepAlive: false,
      headerTheme: 'dark',
      hideHeader: false, // 游戏中心显示header
    }
  },
  {
    path: '/game',
    name: 'Game',
    component: () => import('../../views/game/index.vue'),
    meta: {
      auth: true,
      title: '密室逃脱',
      keepAlive: false,
      headerTheme: 'dark',
      hideHeader: true, // 游戏页面隐藏header
    }
  },
    {
    path: '/game-hosting',
    name: 'GameHosting',
    component: () => import('../../views/game/hosting.vue'),
    meta: {
      auth: true,
      title: '游戏托管',
      keepAlive: false,
      headerTheme: 'dark',
    }
  },
  {
    path: '/node',
    name: 'Node',
    component: () => import('../../views/node/index.vue'),
    meta: {
      auth: true,
      title: '节点',
    }
  },
  {
    path: '/stake',
    name: 'Stake',
    component: () => import('../../views/stake/index.vue'),
    meta: {
      auth: true,
      title: '质押',
    }
  },
  {
    path: '/swap',
    name: 'Swap',
    component: () => import('../../views/swap/index.vue'),
    meta: {
      auth: true,
      title: '兑换',
    }
  }
]

